module.exports = __webpack_public_path__ + "img/nutrition-child-1.b944b049.png";